"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logoutFilter = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const createClient_1 = require("../createClient");
const AUTH_PATH = '/auth';
const TOKEN_PATH = `${AUTH_PATH}/token`;
const EXPIRATION_COOKIE_TIME = 4 / 48; // 2 Horas
let API_BASE_URL;
let COOKIE_NAME;
function useShouldBeAuthenticated(authenticationParams) {
    var _a;
    COOKIE_NAME = authenticationParams.authorizationCookieName;
    let domain = window.location.hostname;
    domain = domain.startsWith('www.') ? domain.replace('www.', '') : domain;
    if (window.location.hash.includes('#id_token=')) {
        js_cookie_1.default.set(authenticationParams.authorizationCookieName, window.location.hash.replace('#id_token=', ''), {
            domain: domain === 'localhost' ? domain : `.${domain}`,
            expires: EXPIRATION_COOKIE_TIME,
            sameSite: 'strict',
            secure: true
        });
        window.history.replaceState({}, document.title, window.location.origin + window.location.pathname);
    }
    const httpClient = (0, createClient_1.createClient)({
        baseURL: authenticationParams.baseURL,
        authorizationCookieName: authenticationParams.authorizationCookieName,
        disableBearer: authenticationParams.disableBearer
    });
    if (authenticationParams.baseURL) {
        API_BASE_URL = `${(_a = authenticationParams.baseURL) === null || _a === void 0 ? void 0 : _a.replace(/[\/]*$/g, '')}`;
    }
    function validateToken() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield httpClient.get((_b = (_a = authenticationParams === null || authenticationParams === void 0 ? void 0 : authenticationParams.tokenValidation) === null || _a === void 0 ? void 0 : _a.path) !== null && _b !== void 0 ? _b : TOKEN_PATH);
                authenticationParams.loginFunction(data);
                return true;
            }
            catch (e) {
                return false;
            }
        });
    }
    function requireAuth() {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            if (!js_cookie_1.default.get(authenticationParams.authorizationCookieName))
                return false;
            return (_c = yield ((_b = (_a = authenticationParams.tokenValidation) === null || _a === void 0 ? void 0 : _a.resolveFunction) === null || _b === void 0 ? void 0 : _b.call(_a))) !== null && _c !== void 0 ? _c : validateToken();
        });
    }
    function shouldBeAuthenticated(to, from, next) {
        return __awaiter(this, void 0, void 0, function* () {
            const isAutenticated = yield requireAuth();
            const sessionUnauthorized = Number(sessionStorage.getItem('unauthenticated'));
            function mountAuthUrl() {
                const authBaseUrl = authenticationParams.baseURL.replace(/[\/]*$/g, '');
                const redirectURI = `?redirect_uri=${window.location.origin}${window.location.pathname}`;
                return `${authBaseUrl}${AUTH_PATH}${redirectURI}`;
            }
            if (!isAutenticated) {
                if (sessionUnauthorized >= 3) {
                    next('/falha-no-login');
                }
                else {
                    sessionStorage.setItem('unauthenticated', (sessionUnauthorized + 1).toString());
                    window.open(mountAuthUrl(), '_self') && next(false);
                }
            }
        });
    }
    return [shouldBeAuthenticated];
}
exports.default = useShouldBeAuthenticated;
function logoutFilter({ cookieName, baseURL }) {
    let domain = window.location.hostname;
    if (domain) {
        domain = domain.startsWith('www.') ? domain.replace('www.', '') : domain;
        js_cookie_1.default.remove(cookieName !== null && cookieName !== void 0 ? cookieName : COOKIE_NAME, { domain: domain === 'localhost' ? domain : `.${domain}` });
        // @ts-ignore
        window.location = `${baseURL !== null && baseURL !== void 0 ? baseURL : API_BASE_URL}${AUTH_PATH}/logout`;
    }
}
exports.logoutFilter = logoutFilter;
